(() => {
    const WebFont = require('webfontloader');
    WebFont.load({
        google: {
            families: ['Jost:400,700:latin-ext']
        }
    });
})();

